import React from 'react';
import {Button, Platform, Text, View} from 'react-native';
// @ts-ignore
import RNRestart from 'react-native-restart';
import {useStyles} from '../hooks/styles';

export interface AppErrorFallbackProps {
  error: Error;
  info?: React.ErrorInfo;
  clearError?: () => void;
}

const reloadApp = () => {
  if (Platform.OS === 'web') {
    window.location.reload();
    return;
  }

  RNRestart.Restart();
};

export const AppErrorFallback = (_props: AppErrorFallbackProps) => {
  const styles = useStyles(() => ({
    root: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      paddingHorizontal: 30,
    },
    text: {
      fontSize: 18,
      textAlign: 'center',
      marginBottom: 15,
    },
    button: {
      width: 160,
    },
  }));

  return (
    <View style={styles.root}>
      <Text style={styles.text}>Произошла ошибка, приносим свои извинения.</Text>
      <View style={styles.button}>
        <Button title='Перезагрузить' onPress={reloadApp} />
      </View>
    </View>
  );
};
